import jaLocale from "element-ui/lib/locale/lang/ja";
const jp = {
  login: {
    buttoo: {
      add: "add",
    },
  },
  dialog: {
    buttton: {
      close: "閉じる",
    },
    ReportError: {
      next: "次へ",
      h1: "エラーレポートはユーザーがデータ問題を解決し、データの品質を向上させるために私たちとコミュニケーションを行うことができる。",
      li1: "データに関する問題や質問がある場合",
      li2: "このデータを改善するために会社情報を提供したい場合 ",
      li3: "プライベートと考える可能性がある企業情報を開示しないことを選択した場合 ",
      li4: "サービスを改善するための建設的な提案がある場合 ",
      h2: "提出されたすべてのコメントはデータ検証の対象である。ユーザーは独自のユーザープロフィールを完了しなければならない。 当社の代表者は,あなたの会社を代表する権利を認証し、確認するためにあなたに連絡することができる。",
      Iamanemployeeofthissubjectcompany: "私は対象会社の従業員です",
      Reportmycompany: "私の会社を告発する",
      Updatedata: "データを更新",
      Reportinformationerrors: "情報エラーを報告",
      Reportotherscompany: "他社を告発する",
      Financial: "財務",
      Pleaseprovidemoreinfo: "詳細情報を提供してください",
      Year: "年",
      Business: "事業",
      Noofemployees: "従業員数",
      Coremanagement: "主要経営陣",
      Corebusinessactivites: "主要事業活動",
      IntBusiness: "国際事業",
      Pleasedescribeyouractivites: "活動内容を記述してください",
      Pleaselistcountriesyoudobusine:
        "事業を行っている国をリストアップしてください",
      Corecompetency: "中核的競争力",
      Businessoutlook: "事業見通し",
      Uploadfiles: "ファイルをアップロード",
      Upload: "アップロード",
      Cancel: "キャンセル",
      Submit: "送信",
      Select: "選択",
      Selectthedatacategoryyoureport: "報告するデータカテゴリを選択",
      TotalCurrentAssets: "流動資産合計",
      CashBank: "現金及び預金",
      Accountreceivable: "売掛金",
      AdvancestoSuppliers: "仕入先前払金",
      Inventory: "棚卸資産",
      Tobeappointedexpense: "繰延資産",
      Totalnoncurrentassets: "固定資産合計",
      Longterminvestment: "長期投資",
      Fixedassetsnetvalue: "固定資産純額",
      Projectsunderconstruction: "建設仮勘定",
      Longtermtobeappointedexpenise: "長期繰延資産",
      Deferredtaxdebit: "繰延税金資産",
      Totalcurrentliabilities: "流動負債合計",
      Accountpayable: "買掛金",
      Advancesfromclients: "顧客前受金",
      Salariespayable: "未払給与",
      Taxespayable: "未払税金",
      Otheraccountspayable: "その他未払金",
      Totalequity: "純資産合計",
      Paidupcapital: "払込資本金",
      Capitalreserves: "資本準備金",
      Surplusreserves: "利益準備金",
      Undistrbutedporfit: "留保利益",
      Totalassets: "資産合計",
      Turnover: "売上高",
      Costofgoodssold: "売上原価",
      Salestax: "販売税",
      Grossprofit: "売上総利益",
      Otheroperatingprofils: "その他営業利益",
      Salesexpense: "販売費",
      Managementexpense: "一般管理費",
      Financeexpense: "財務費用",
      Operatingprofit: "営業利益",
      Nonoperatingincome: "営業外収益",
      Profitbeforetax: "税引前当期純利益",
      Incometax: "法人税等",
      Netincome: "当期純利益",
      DataProblems: "データの問題",
      CorrectInformation: "正しい情報",
    },
  },
  Home: {
    Applications: "アプリケーション",
    SearchCompanies: "企業検索",
    SearchLeads: "潜在顧客検索",
    SearchTrade: "貿易検索",
    SearchSanctions: "制裁検索",
    SearchNews: "ニュース検索",
    RiskScan: "リスクスキャン",
    SearchRelationship: "関係検索",
    DataServices: "データサービス",
    SearchCountries: "国/地域検索",
    selectCountry: "国/地域を選択",
    Entercompanyname: "会社名を入力してください",
    keWord: "キーワード",
    firstWord: "先頭文字",
    search: "検索",
    homeSeachTitle: "グローバルビジネスに焦点を当てる",
    homeTitleDetail:
      "CSIは、データドリブン型の調査・IT企業として、信用、リスク、ビッグデータの分野に特化しています。世界中の投資家やビジネスプロフェッショナルにデジタルツールを提供し、高度な分析手法とアルゴリズムを活用して、迅速かつ視覚的なインサイトを提供し、より賢明な意思決定を支援します。",
    phoneTitleDetail:
      "携帯電話のCSIアプリを使って、迅速に会社情報を検索・閲覧・取得することができます。",
    searchCompanyNum: "200以上の国や地域で5億社以上の企業を検索する",
    newsHeadTitle:
      "すべての企業ニュースの背後にある戦略的インサイトを解明します。",
    sanctionHeadTitle: "グローバル貿易データを戦略的市場インサイトに変換​",
    tradeHeadTitle:
      "グローバル貿易データを戦略的市場インサイトに変換市場インサイト",
    relationshipTitle:
      "最終所有・支配・投資軌跡／サプライチェーン／コンプライアンス最適化／リスク軽減／グローバル対応",
    IndustryAnalysis: "業界分析",
    BusinessAnalytics: "ビジネス分析",
    ImportExportData: "データのインポートとエクスポート",
    CompanyNews: "社内ニュース",
    Sanctions: "制裁",
    BusinessIntelligence: "ビジネスインテリジェンス",
    CompanyIdentityVerification: "会社識別認証",
    KYCSolutions: "KYCソリューション",
    OwnershipPenetration: "所有権の浸透",
    CompanyFinancialAnalysis: "会社財務分析",
    CreditRatings: "信用格付け",
    CreditReports: "与信レポート",
    ESGRatings: "ESG格付け",
    VendorScreening: "ベンダー選定",
    MarketResearch: "市場調査",
    EnterKeyword: "キーワードを入力",
    Country: "国/地域",
    Company: "会社名",
    Person: "人",
    Product: "製品",
    EnterPersonName: "氏名を入力",
    EnterCountryName: "国名を入力",
    EnterproductName: "製品キーワードを入力してください",
    EnterproductNamekeywordsorHSCode:
      "製品キーワードまたはHSコードを入力してください",
    Searchby: "検索条件",
    SICStandardIndustryCode: "SIC - 標準業界コード",
    HSCodeHarmonizedSystemCode: "HSコード -調和関税システムコード",
    AIAssistance: "AIアシスタント",
    EnterISICNACENAICSCSICAAAICGICS:
      "ISIC/NACE/NAICS/CSIC/AAAIC/GICSを入力してください",
    EnterHarmonizedSystemCode: "調和関税システムコードを入力してください",
    SIC: "SIC",
    HSCode: "HSコード",
  },
  Toolbar: {
    Filter: "フィルター",
    Select: "選択",
    Edit: "編集",
    Sortby: "ソート順",
    Collect: "お気に入り",
    Saved: "保存済み",
    Compare: "比較",
    Export: "エクスポート",
    Download: "ダウンロード",
    Update: "アップデート",
    Reporterror: "エラー報告",
    Share: "シェア",
    ascending: "昇順",
    descending: "降順",
    Yourfolder: "カスタムフォルダ",
    RiskScanning: "リスクスキャン中",
    CreditAssessment: "信用評価",
    DataAnalysis: "データ分析",
    NewPortfolio: "新規ポートフォリオ",
    Print: "印刷",
    Optimize: "最適化する",
    ALL: "全部",
    Confirm: "確認",
  },
  Export: {
    Choosethedatafields: "エクスポートするデータ項目を選択",
    Enterkeywords: "キーワードを入力",
    Financialdata: "財務データ",
    Reset: "リセット",
    Back: "戻る",
    Howmanyresults:
      "この検索結果から何件をエクスポートしますか？追加のフィルターを設定することも可能です。",
    FileName: "ファイル名",
    Pleaseenterafilename: "ファイル名を入力してください",
    SelectedList: "選択済みリスト",
  },
  AiZaba: {
    whatareyousearchingfor: "何を探していますか?",
    CreditAnalyst: "信用分析",
    Assesses:
      "会社の信用価値を評価し、財務リスクを特定し、データ分析と信用評価を通じて安全な取引を確保します。",
    LegalAdvisor: "法律顧問",
    Provides:
      "コンプライアンスガイダンスを提供し、契約を審査し、ビジネス運営が法律に準拠し、紛争を避けるためにリスクを評価します。",
    BizConsultant: "ビジネスコンサルタント",
    Optimizes:
      "サプライチェーンを最適化し、購入者を識別し、市場の傾向を分析し、効率を向上させるためのカスタマイズされた戦略を提供することによって販売を高めます。",
    EconomicAnalyst: "経済アナリスト",
    Analyzes:
      "業界と地域経済の動向を分析し、ビジネスが情報に基づく決定を下し、競争力を維持するための支援を行います。",
    HiImZabaYourresearchassistant:
      "こんにちは、私はZabaです。あなたのリサーチアシスタントです。",
  },
  navigationBar: {
    Notifications: "通知", //通知
    MarkasRead: "既読", //标记已读
    Viewall: "全表示", //查看全部
    SilverSubscriber: "シルバー会員", //银级用户
    GoldSubscriber: "ゴールド会員", //金级用户
    SubscriptionExpires: "サブスクリプション有効期限",
    AvailableCredits: "有効ポイント", //可用积分
    AddCredits: "ポイント購入", //购买积分
    IndivdualAccount: "個人口座", //个人账号
    GroupAccount: "法人・社団体アカウント", //集团账号
    UserAccount: "ユーザーアカウント",
    Roles: "役割", //角色
  },
  ListofResults: {
    Country: "国/地域",
    Industry: "業界",
    CompanyType: "会社種類",
    CompanySize: "会社規模",
    CompanyStatus: "会社状況",
    CompanyName: "会社名",
    RegStatus: "登記状況",
    StateProvince: "都道府県",
    CityCounty: "市/郡",
    DistrictCity: "地区/市",
    IncDate: "株式会社成立日",
    LegalForm: "法的形態",
    CoID: "会社ID",
    TaxNo: "税務番号",
    ListingInfo: "上場情報",
    Phone: "電話",
    Website: "ウェブサイト",
    Email: "メール",
    LegalPerson: "法定代表者",
    PostCode: "郵便番号",
    ISIC: "ISIC",
    IndustryDescription: "業界説明",
    NACE: "NACE",
    NAICS: "NAICS",
    CreditRating: "信用格付け",
    SolvencyIndex: "ソルベンシー指数",
    ProbabilityofDefault: "違約率",
    NoofEmployees: "従業員数",
    Revenue: "収入",
    TotalAsset: "総資産",
    NetProfit: "純利益",
    ROA: "ROA",
    ROE: "ROE",
    ShowMore: "もっと表示する",
    SelectCountry: "国/地域選択",
    ClearAll: "すべてクリア",
    SelectIndustry: "業界選択",
    ListedCompany: "上場状況",
    YearsinBusiness: "営業年数",
    Sharethisinformation: "情報を共有する",
    Pleaseaddress: "1つ以上のメールアドレスを入力してください",
    Example: "例",
    message: "メッセージ",
    pleaseleaveamessage: "メッセージを残してください",
    Include: "含む",
    thisaddress: "会社名、ID、住所",
    CSIwebsite: "CSIウェブサイト",
    Update: "更新",
    Iftheavailable:
      "利用可能なオンラインデータが不十分または古くなった場合は、「更新」ボタンをクリックして、当社のローカルネットワーク調査員またはクレジットレポート機関から新しい調査されたビジネスクレジットレポートの即時更新を要求することができる。この更新の費用は会社ごとに1クレジットである。更新レポートは通常24時間から72時間までかかる。",
    Abusinesscredit:
      "ビジネスクレジットレポートは、対象会社の識別データ、登録記録、株主構造、会社歴史、経営説明、関連会社、実際の運営、貿易参照、財務データと分析、訴訟記録と制裁などの公式公開情報、信用分析と評価に関する詳細な情報を提供する。",
    Searchcompanies: "他の企業のメールを検索する",
    Rowsperpage: "ページごとの行数",
    Remove: "削除",
    Confirm: "確認",
  },
  ContentTabs: {
    Background: "背景",
    BusinessActivities: "ビジネス活動",
    Performance: "パフォーマンス",
    Publications: "公開記録",
    CreditOpinion: "信用評価",
    MarketAnalysis: "市場分析",
    Snapshot: "スナップショット",
    Profile: "登記情報",
    Ownership: "所有権",
    RelatedCompanies: "関連会社",
    Management: "経営陣",
    Operations: "運営情報",
    Locations: "拠点分布",
    Industry: "業界",
    ImportExport: "輸入＆輸出",
    SupplyChain: "サプライチェーン",
    FinancialHighlights: "財務概要",
    RatioAnalysis: "比率分析",
    IndustryNorm: "業界標準",
    News: "ニュース",
    Sanctions: "制裁",
    IndustryStatistics: "業界統計",
    RatingAnalysis: "評価分析",
    CompetitiveAnalysis: "競争分析",
  },

  Snapshot: {
    CompanyDQIdesc1:
      "データ品質指数 (DQI) は、完全性、有効性、ソースの信頼性、一致性、タイムリンシュ、両言語サポートなど、データのさまざまな側面を評価するためにアルゴリズムを使用する。",
    CompanyDQIdesc2:
      "このインデックスは、データの質を1から100のスケールで評価するために設計され、より高いスコアは優れたデータの質を示してる。アルゴリズムは、事前に定義されたルールや基準に基づいてデータを分析することができ,客観的で標準化された測定を可能になる。",
    CompanyDQIdesc3:
      "当社のデータ品質指数 (DQI) は信頼性の高い指標として機能し、ユーザーがデータの品質を定量的に評価することができる。これにより、データに基づく意思決定が可能になり、データの全体的な価値と有用性が高まる。",
    CountryDQIdesc1:
      "データ品質指数 (DQI) は、各国間のデータの信頼性、正確性、アクセシビリティを評価し、デジタルインフラ、ガバナンス、透明性の違いを反映する。先進国は通常、強力なデータシステム、オープンな政策、先進テクノロジーにより、より高いランキングを得ている一方、開発途上国はインフラ、規制、データ共有の実践におけるギャップに苦しんでいる。",
    CountryDQIdesc2:
      "主要な要因には、政府の透明性、データ保護法、技術の採用が含まれている。高いDQIは、より良い政策決定とビジネス決定を可能にする一方、低いスコアは、資が必要な領域を強調する。",
    CompanyDQI: "会社DQI", //公司数据质量指数 DQI
    CountryDQI: "国DQI", //国家数据质量指数 DQI
    CompanyTitle: "会社別データ品質指数 (DQI) ",
    CountryTitle: "国別データ品質指数 (DQI) ",
    Address: "アドレス", //地址
    CountyCity: "市区町村", //县/市
    ProvinceState: "都道府県", //省/州
    CountryRegion: "国/地域", //国家/地区
    ZipCode: "郵便番号", //邮政编码
    Website: "ウェブサイト", //网站
    Email: "メール", //电邮
    Tel: "電話", //电话
    LastUpdate: "最終更新日", //最近更新
    DataSource: "データソース", //数据来源
    LegalStatus: "法律状況", //法定状况
    CoID: "会社ID", //公司ID
    CompanyType: "会社種類", //公司类型
    RegistrationDate: "設立年月日", //注册日期
    RegistrationStatus: "登録状況", //注册状态
    Listed: "上場有無", //上市信息
    CurrentOpperations: "ビジネス状況", //经营状况
    IndustryCode: "業界コード", //行业代码
    BusinessActivities: "主要業務", //主营业务
    NoofEmployees: "従業員数", //员工数量
    NoofShareholders: "株主数", //股东数量
    Management: "管理状況", //管理状况
    Performance: "業務状況", //业绩表现
    Revenue: "収入", //收入
    Assets: "資産", //资产
    ProfitLoss: "利益", //利润
    Growth: "会社成長", //公司增长
    Competitiveness: "競争力", //竞争力
    CreditOpinion: "信用評価", //信用状况
    CreditRating: "信用格付け", //信用评级
    CreditScore: "信用点数", //信用评分
    ESGRating: "ESGレベル", //ESG 评级
    Solvency: "ソルベンシー", //偿还能力
    Sanctions: "グローバル制裁", //全球制裁
    CoName: "会社名",
    RegName: "登録名称",
  },
  Profile: {
    CompareCompanies: "会社の比較",
    AddaCompany: "会社の追加",
    SubjectCompany: "対象会社", //目标公司
    ComparisonCompany: "比較対象会社",
    CompanyProfile: "会社概要", //基本资料
    CompanyName: "会社名", //公司名称
    NativeName: "現地名", //当地名称
    CompanyID: "会社ID", //公司 ID
    VATNumber: "VAT番号", //VAT号
    StockCode: "株式コード", //股票代码
    Listed: "上場", //上市日期
    RegistrationDate: "設立年月日", //注册日期
    LegalForm: "法的形態", //公司性质
    CompanyType: "会社種類", //公司类型
    LegalStatus: "法律状況", //注册状态
    Jurisdiction: "管轄権", //司法管辖区
    RegisteredAddress: "登録アドレス", //注册地址
    ProvinceState: "都道府県", //省/州
    CountryRegion: "国/地域", //国家/地区
    ZipCode: "郵便番号", //邮政编码
    OperatingAddress: "経営アドレス", //经营地址
    LastUpdate: "最終更新日", //最近更新
    DataSource: "データソース", //数据来源
    History: "歴史", //历史记录
    RegisteredCapital: "登録資本金",
    PaidinCapital: "払込資本金",
    CountyCity: "市区町村",
    OtherName: "その他名前",
  },
  Ownership: {
    TotalPartiesInvolved: "関係者合計",
    UltimateBeneficiaryOwner: "最終受益者 (UBO)", //最终受益人
    NaturalPersonShareholder: "自然人株主",
    InvolvingEnterprises: "法人株主",
    ShareholderLevel: "株主レベル", //股东层级x
    Name: "名称", //名称
    Country: "国/地域", //国家/地区
    Location: "所在地", //地点
    Type: "種類", //类型
    Shares: "シェア", //股份
    Relation: "関係", //关系
    RelatedCompany: "関連会社",
    CompanyShareholders: "会社株主",
    NGOShareholders: "NGO株主",
    SubjectInvestments: "主体投資",
  },
  RelatedCompanies: {
    Total: "総事業体数", //相关公司总计
    Entities: "事業体", //法人实体
    Countries: "国/地域", //国家/地区
    Branches: "支店", //分支机构
    RelatedComp: "関連会社", //关联公司
    Name: "名", //名称
    Country: "国/地域", //国家/地区
    Location: "所在地", //地点
    Type: "種類", //类型
    Relationship: "関係", //关系
    BranchOffices: "支店",
    Subsidiaries: "子会社",
  },
  Management: {
    Management: "管理", //管理层
    ContactInfo: "連絡者", //联系人信息
    Countries: "国", //国家/地区
    Name: "名", //名称
    Position: "職位", //职位
    Department: "部门", //部门
    Country: "国/地域", //国家/地区
    ShareholderNot: "株主かどうか", //是否股东
    Relation: "関係", //关系
    Verification: "検証", //已验证
    Searchmoreemails: "もっとメールを検索する", //搜索更多电邮
    Roles: "役割", //角色
    EducationLevel: "教育レベル", //教育程度
    Phone: "電話番号", //电话
    Email: "メール", //电邮
    Verified: "確認", //已验证
    Searchmore: "他の会社のメールを検索する", //搜索更多其他公司的电邮
    Pleaseentername: "名前を入力してください",
    PleaseenterWebsite: "会社名またはドメインを入力してください",
    UserSelfVerification: "ユーザー自己認証",
    Userverified: "ユーザー検証済",
    Source: "ソース",
  },
  Operations: {
    LineofBusiness: "事業分野", //业务范围
    BusinessTerritories: "ビジネス領域", //业务区域
    ImportExport: "輸入＆輸出", //进出口信息
    Viewtradeinfo: "もっと貿易情報を見る", //查看更多贸易信息
    ProductsServices: "製品/サービス", //产品/服务
    Products: "製品", //产品
    ProductImage: "製品イメージ", //产品图片
    ProductName: "製品名", //产品名称
    ProductDescription: "製品説明", //产品描述
    Details: "詳細", //详情
    Addproductinformation: "製品情報を追加する", //添加产品信息
    Showcaseyourcompany:
      "会社の製品やサービスを公開したい場合は、ここに製品やサービス情報を追加することができます。これはビジネスの発展を促進する良い方法です。提出内容が検討された後、データが公開されます。",
  },
  Locations: {
    CoName: "会社名", //业务范围
    Relationship: "関係", //关系
    Type: "種類", //类型
    Country: "国/地域", //国家/地区
    Location: "所在地", //地点
    Address: "アドレス", //地址
    Edit: "編集", //编辑
    CompanyLocatiionsMap: "地図上の会社の位置", //地图中的公司位置
    Selectaddresstype: "アドレスタイプを選択してください", //选择地址类型
    Subjectcompany: "対象会社", //目标公司
    Subsidiary: "子会社", //子公司
    RegisteredAddress: "登録アドレス", //注册地址
    OperationAddress: "営業所アドレス", //运营地址
    All: "全部", //全部
    Showlocation: "位置表示",
  },
  Industry: {
    IndustryTitle: "業界タイトル", //IndustryTitle
    IndustryDescription: "業界説明", //IndustryDescription
    ISIC: "ISIC", //ISIC
    ISICDescription: "ISIC説明", //ISICDescription
    NACE: "NACE", //NACEDescription
    NACEDescription: "NACE説明", //NACEDescription
    NAICS: "NAICS", //NAICS
    NAICSDescription: "NAICS説明", //NAICSDescription
    CSIC: "CSIC", //CSIC,
    CSICDescription: "CSIC説明", //CSICDescription
    AAAIC: "AAAIC", //AAAIC
    AAAICDescription: "AAAIC説明", //AAAICDescription
    GICS: "GICS", //GICS
    GICSDescriptio: "GICS説明", //GICS 描述
  },
  ImportExport: {
    TotalImportAmount: "総輸入額", //进口总额
    TopImportCountry: "最大輸入国", //最大进口国家/地区
    TopImportProduct: "最大輸入製品", //最大进口产品
    TotalExport: "総輸出額", //出口总额
    TopExportCountry: "最大輸出国", //最大出口国家/地区
    TopExportProduct: "最大輸出製品", //最大出口产品
    TradeVolume: "取引量", //贸易额
    ImportShipments: "輸入運送", //进口量
    ExportShipments: "輸出運送", //出口量
    ImportCountries: "輸入国", //进口国家/地区
    ExportCountries: "輸出国", //出口国家/地区
    ImportVolume: "輸入量", //进口量
    ExportVolume: "輸出量", //出口量
    Suppliers: "トップサプライヤー", //主要供应商
    Shipments: "運送数量", //按出货量
    Buyers: "トップバイヤー", //主要买家
    ImportQuantity: "輸入量", //进口数量
    IncreaseDecreasexRate: "増加/減少率", //增/减率
    ExportQuantity: "輸出量", //出口数量
    ImportsExportsRecords: "輸入＆輸出記録", //进出口记录
    Date: "日付", //日期
    Product: "製品", //产品
    HSCode: "HSコード", //HS 编码
    BuyerName: "バイヤー名", //买家名称
    Destination: "目的地", //目的地
    SupplierName: "サプライヤー名", //供应商名称
    Origin: "出発地", //原产地
    Amount: "金額 (USD)", //金额
    Details: "詳細", //详情
    Imports: "輸入",
    Exports: "輸出",
    Shipments2: "出荷数量",
    value2: "価値",
    value: "価値順",
    viewmoretradeinfo: "詳細な貿易情報の表示",
    SearchHSCode: "HSコード検索",
    Selectdate: "日付を選択",
  },
  SupplyChain: {
    Illustratesthesubjectcompany:
      "このグラフは、ターゲット企業の「購入」と「販売」の関係を示しています。体積が大きいほど、パイプは厚くなります。",
  },
  ShippingOrderDetails: {
    Date: "日付",
    MasterBillofLading: "マスター船荷証券",
    Source: "ソース",
    BillNo: "請求書番号",
    ImporterBuyer: "輸入者/購入者",
    ExporterSeller: "輸出者/販売者",
    Name: "名",
    Address: "アドレス",
    Country: "国/地域",
    Contact: "連絡先",
    Email: "メール",
    CargoInfo: "貨物情報",
    HSCode: "HSコード",
    Quantity: "数量",
    WeightUnit: "重量単位",
    ProductDescription: "製品説明",
    Amount: "金額 (USD)",
    QuantityUnit: "数量単位",
    Weight: "重量",
    HSDescription: "HS説明",
    Incoterms: "インコタームズ",
    ShippingInfo: "出荷情報",
    Vessel: "船",
    Consignee: "荷受人",
    MeansofTransport: "輸送手段",
    CountryofOrigin: "出発国",
    Voyage: "航行",
    Notifier: "通知者",
    CountryofDestnation: "目的国",
    AddressofOrigin: "出発地アドレス",
    Shipper: "出荷者",
    AddressofDestnation: "目的地アドレス",
    Container: "コンテナ",
    ContainerID: "コンテナID",
    ContainerType: "コンテナタイプ",
    ContainerDescDode: "コンテナDescコード",
    ContainerSize: "コンテナサイズ",
    ImportExport: "輸入者 / 輸出者",
    Imports: "輸入",
    Exports: "輸出",
  },
  FinancialHighlight: {
    Revenue: "収入",
    Profit: "利益",
    Growth: "成長",
    CashFlowStatus: "キャッシュフローの状況",
    FinancialStructure: "財務構造",
    CreditOpinion: "信用評価",
    RiskIndicator: "リスク指標",
    Solvencyindex: "ソルベンシー指数",
    Year: "年",
    Change: "変更",
    NetProfit: "純利益",
    TotalAssets: "総資産",
    Equity: "純資産",
    GrossMargin: "粗利率",
    ProfitMargin: "粗利",
    ReturnonEquity: "純資産収益率",
    CurrentRatio: "流動比率",
    DebtRatio: "負債比率",
    FinancialHighlights: "関連会社からの財務データ",
    FinancialHighlightsTitle: "関連会社からの財務概要",
    CompanyName: "会社名",
    CompanyID: "会社ID",
    Country: "国/地域",
    CompanyStatus: "会社状況",
    Cancel: "取消",
    Select: "選択",
    Relations: "関係",
    Financialperformancedata:
      "財務実績データは、様々な政府機関や地元信用情報機関から収集されており、さらに市場・業界調査を用いて計算・モデル化されています。実際の運営状況や業績分析に関するより詳細な情報については、当社サービスチームまでご連絡いただき、企業デューディリジェンスレポートの提出をお申し込みください。",
    Whenthesubjectsdata:
      "対象者のデータが不十分な場合、または顧客に関するより深い洞察を求める際、このプラットフォームは対象者に関連するすべてのエンティティを包括的に表示します。これには対象者の会社の株主、関連企業などが含まれます。 ",
    Byprovidingyou:
      "より広い視野を提供することで、このプラットフォームは情報に基づいた評価を行い、対象についてより深い理解を得られるように支援します。",
    PleaseSelectTheYeartoDisplay: "表示する年を選択してください",
    SelectUptoThreeYears: "最大3年間の選択",
  },
  RatioAnalysis: {
    ProfitabilityRatios: "収益率",
    Year: "年",
    Change: "変更",
    Returnonequity: "純資産収益率",
    Returnonassets: "資産収益率",
    Profitmargin: "粗利",
    Grossmargin: "粗利率",
    OperatingRatios: "運営比率",
    Assetsturnover: "資産回転率",
    Stockturnover: "在庫回転率",
    Salesperiod: "販売期間",
    Collectionperiod: "回収期間",
    Creditperiod: "信用期間",
    StructuralRatios: "構造比率",
    Currentratio: "流動比率",
    Quickratio: "当座比率",
    Shareholdersliquidityratio: "株主流動性比率",
    Solvencyratio: "ソルベンシー比率",
    Debtratio: "負債比率",
    ProductivityRatios: "生産率比率",
    Profitperemployee: "一人当たり利益",
    Operatingrevenueperemployee: "一人当たり営業収入",
    Shareholdersfundsperemployee: "一人当たり株主資本金",
    Totalassetsperemployee: "一人当たり総資産",
    GrowthRatios: "成長率",
    Salesgrowthrate: "売上成長率",
    Netprofitgrowthrate: "純利益成長率",
    Totalassetsgrowthrate: "総資産成長率",
    FinancialHighlights: "関連会社からの財務データ", //关联公司财务数据
    RatioAnalysis: "関連会社からの比率分析", //关联公司比率分析
    CompanyName: "会社名",
    CompanyID: "会社ID",
    Country: "国/地域",
    CompanyStatus: "会社状況",
    Relations: "関係",
  },
  IndustryNorms: {
    IndustryStatistics: "業界統計",
    ofcompaniesintheIndustry: "業界内会社数",
    oflistedCompaniesintheIndustry: "業界内上場会社数",
    oflargecompaniesintheIndustry: "業界内大手会社数",
    ofSMEsintheIndustry: "業界内中小会社数",
    ofcompaniesinsample: "サンプル会社数",
    ofcompaniesinloss: "赤字会社数",
    Observations: "観測",
    AverageValue: "平均値",
    MedianValue: "中央値",
    MaximumValue10: "最大値10％",
    MinimumValue10: "最小値10％",
    SubjectCompany: "対象会社",
    YearsinBusiness: "営業年数",
    TotalAssets: "総資産",
    TotalEquity: "総資本",
    Revenue: "収入",
    NetEarning: "純利益",
    Returnonassets: "資産収益率",
    Performance: "パフォーマンス",
    ProfitabilityRatios: "収益率",
    Returnonequity: "純資産収益率",
    Grossmargin: "粗利率",
    OperatingRatios: "運営比率",
    Stockturnover: "在庫回転率",
    Accountsreceivableturnover: "売掛金回転率",
    Assetsturnover: "資産回転率",
    Totalassetturnover: "総資産回転率",
    StructuralRatios: "構造比率",
    Currentratio: "流動比率",
    Quickratio: "当座比率",
    Shareholdersliquidityratio: "株主流動性比率",
    GrowthRatios: "成長率",
    Salesgrowthrate: "売上成長率",
    Netprofitgrowthrate: "純利益成長率",
    Totalassetsgrowthrate: "総資産成長率",
  },
  Lawsutis: {
    Litigations: "訴訟",
    Date: "日付",
    CaseType: "ケースタイブー",
    Title: "ケースタイトル",
    CaseNo: "ケース番号",
    CauseofAction: "訴訟の原因",
  },
  News: {
    Date: "日付", //日期
    Title: "タイトル", //标题
    Source: "ソース", //来源
    Impact: "影響度", //影响
    Searchcompanies: "他の会社のニュースを検索してください", //国家/地区
    SearchforTitle: "タイトル検索",
    CompanyName: "会社名",
    Industry: "業界",
    Subjects: "テーマ",
    NewsTypes: "ニュースの種類",
    ByDate: "日付で絞り込み",
    SelectCompanyName: "会社名を選択",
    SelectIndustry: "業界選択",
    SelectSubjects: "対象者を選択",
    SelectNewsType: "ニュース種別を選択",
    Negative: "ネガティブ",
    Positive: "ポジティブ",
  },
  Sanctions: {
    Potentialcompliance: "潜在的なコンプライアンスリスクを検出した", //检测到潜在合规风险
    SeachbuttonNo: "この会社には有害的なことを検出しない", //未检测到任何与该公司相关的不良记录
    SeachbuttonYes: "もっと制裁記録を検索する場合、「制裁検索」ボタンを押す", //要搜索更多制裁记录，请点击“搜索制裁”按钮。
    SearchSanctions: "制裁検索",
    ViewDetails: "詳細表示",
    Sanctions: "制裁",
    Potentialcompliancerisks: "潜在的なコンプライアンスリスク",
    IDInfo: "ID情報",
    IDType: "ID類型",
    IDDescription: "ID説明",
    SanctionList: "制裁リスト",
    SanctionListInvolved: "関連制裁リスト",
    StartDate: "開始日",
    EndDate: "終了日",
    SourceList: "ソースリスト",
    SourceName: "ソース名",
    ProfileNotes: "プロフィール備考",
    Link: "リンク",
    Name: "名",
    AssociationList: "協会リスト",
    AssociationID: "協会ID",
    AssociationType: "協会タイプ",
  },
  CreditOpinion: {
    CreditAssessment: "信用評価",
    CreditAssessmentfromtheRelatedCompanies: "関連会社からの与信評価",
    Year: "年",
    CreditRating: "信用格付け",
    LocalCreditScore: "ローカル与信点数",
    ProbabilityofDefault: "違約率",
    SolvencyIndex: "ソルベンシー指数",
    CreditLine: "与信金額",
    RiskIndicator: "リスク指数",
    RelatedCreditAssessment: "関連与信評価",
    CompanyName: "会社名",
    CompanyID: "会社ID",
    Country: "国/地域",
    CompanyStatus: "会社状況",
    Relations: "関係",
    Cancel: "取消",
    Select: "選択",
    CreditAssessmentMessage1:
      "対象のデータが不十分な場合、または顧客に対するより多くの洞察を得ることに興味がある場合、このプラットフォームは、対象に関連するすべてのエンティティの包括的なビューを提供する。これには、対象会社の株主、関連会社などが含まれている。 ",
    CreditAssessmentMessage2:
      "より広い視点を提供することにより、このプラットフォームは、より情報のある評価を行い、主題についてより深い理解を得ることができる。",
    LocalCreditRating: "地元クレジット評価",
    LocalCreditRatingDetail:
      "ビッグデータの力に基づいて、3ARatingは民間企業のための定量的な評価システムである。これは3ACreditとCreditreform Ratingの共同努力である。評価モデルは、非財政要因、財政要因、負の記録、業界特定の考慮事項を含む様々な重要な要因の包括的な評価に基づいて構築されている。評価モデルは印象的なギニ系数を示し、その堅固さと信頼性を示している。3ARatingは、最高の評価、3A1から最低の評価、3A19までの範囲にわたる。",
    CreditScore: "信用点数",
    CreditScoreDetail:
      "クレジットスコアは,地方自治体から得たクレジット評価に基づいて、1から100のスケールで計算される。より高いスコアは、より良い信用価値を示す。",
    PossibilityofDefault: "違約可能性（PD）",
    PossibilityofDefaultDetail:
      "違約可能性（PD）は、短期的な流動性評価に焦点を当てたリスク評価の有用なツールである。",
    SolvencyIndexSI: "ソルベンシー指数（SI）",
    SolvencyIndexSIDetail:
      "ソルベンシー指数（SI）は、ビジネスパートナーのソルベンシーの迅速な評価を可能にする効果的で信頼性の高い早期警告指標である。高いSI値は、クライアントによるデフォルトのリスクが高いことを示す。SIは、優れた評価と考えられる100から、非常に負の特徴が存在する600までである。",
    ExternalRating: "外部評価",
    DefaultProbability: "違約確率 (Pd1Year)",
    Rating: "3A評価 (>=,<=)",
    PleaseSelectTheYeartoDisplay: "表示する年を選択してください",
    SelectUptoThreeYears: "最大3年間の選択",
    HighRisk: "ハイリスク",
    Medium: "ミディアムリスク",
    Moderate: "モデレートリスク",
    Average: "平均",
    LowerThanAvg: "平均以下",
    LowRisk: "ローリスク",
    CreditOpinion: "信用評価",
  },
  IndustryStatistics: {
    SubjectCompany: "対象会社",
    Country: "国/地域",
    Compare: "比較",
    Industry: "産業",
    CompanyType: "会社類型",
    CompanySize: "会社規模",
    CompanyStatus: "会社状況",
    YearsinBusiness: "営業年数",
    CompanyRating: "会社レベル",
    Liquidity: "流動性",
    NoofcoinIndustry: "会社業界番号",
    IndustryRating: "業界評価",
    Profitability: "収益性",
    Growth: "成長率",
    FinancialStructurt: "財務構造",
    Solvency: "返済能力",
    SearchCountry: "国検索",
  },
  RatingAnalysis: {
    IndustyAnalysis: "産業分析",
    GeographicAnalysis: "地理分析",
    CompanyTypeAnalysis: "会社類型分析",
    BiusinessScaleAnalysis: "ビジネス規模分析",
    HistoryAnalysis: "歴史分析",
    NormalDistribution: "正規分布",
    SubjectCompany: "対象会社",
    Probabilityofthesubjectratinginitsindustry: "業界内対象評価率",
    Maximum: "Max 10%",
    Mean: "中央値",
    Average: "平均値",
    Minimum: "Min 10%",
    RatingDistribution: "評価分布",
    Revenue: "収入",
    Earning: "利益",
    TotalAssets: "総資産",
    Subjectratinginitsindustrybyfinancialindicators: "業界内対象財務指標評価",
    Best: "最高",
    Worst: "最低",
    Rankingofsubject: "業界内対象評価ランキング",
    Industy: "産業",
    Percentilerank: "比率ランキング：％対象の会社を超える",
    Historicaldevelopmentofsubject: "業界内対象評価の発展歴史",
    IndustryAverage: "業界平均",
    SubjectRatingChanges: "対象評価変動",
    CreditScore: "信用点数",
    NOofCompanies: "会社数",
    ofCompanies: "%企業",
    CreditRating: "信用格付け",
    CompanySize: "会社規模",
    YearsinBusiness: "営業年数",
    SubjectsIndustryConcentrationAnalysis: "主体業界の集中度分析",
    GeographicdistributionofSubjectsratingintsindustry:
      "業界における被験者の評価地理的分布",
    GeographicdistributioninSubjectindustry:
      "被験者が所属する業界の地理的分布：",
    RatingDistributioninSubjectsLocation: "被験者所在地のスコア分布",
    Ratinganalysisofcompanies: "同業種の異なる経営年限会社の格付け分析",
    Subjectsratinghistory: "同じ歴史を持つ同業者と比較した被験者のスコア履歴",
    Ratingrankingofcompanieswithsamehistory:
      "同じ履歴を持つ企業の格付けランキング",
    Ratingstatistics: "同年の経営企業格付け統計",
    Subjectratingcomparing: "同業他社と比較したトピック評価",
    Subjectratinginitsgroup: "グループ内の被験者スコア：",
    Analysisbasedonnature: "主体業界の企業特性に基づく分析",
    Subjectratingpositioninitscompanytype: "企業タイプのトピック評価の場所:",
    Ratingstatisticsofcompanies: "同業企業の格付け統計",
    Ratinganalysisofcompanies: "同業他社の格付け分析",
    Probabilityofsubjectrating: "その規模の範囲内で、その業界の学科格付け確率",
    Subjectratingcomparingwithindustry: "同業他社とのトピック評価:",
    RatingRankingofthecompanies: "同業同規模企業の格付けランキング",
    Ratingstatisticsofcompanies: "同規模・同業界企業格付け統計",
    Rank: "ランキング",
    Rating: "評価",
    CompanyType: "会社類型",
  },
  CompetitiveAnalysis: {
    MarketPosition: "市場地位",
    Revenus: "収入",
    NetEarnings: "純利益",
    NetAssets: "純資産",
    TotalAssets: "総資産",
    Employees: "従業員",
    Mean: "中央値",
    Average: "平均値",
    Maximum: "Max (10%)",
    Worst: "Worst (10%)",
    Subjectcompany: "対象会社",
    PerformanceComparison: "表現比較",
    ProfitabilityRatios: "収益率",
    Grossmargin: "粗利率",
    Returnonassets: "資産収益率",
    Returnonequity: "純資産収益率",
    OperatingRatios: "運営比率",
    Stockturnover: "在庫回転率",
    Assetsturnover: "資産回転率",
    Currentassetturnoverrate: "流動資産回転率",
    Collectionperiod: "回収期間",
    GrowthRatios: "成長率",
    Totalassetsgrowthrate: "総資産成長率",
    Salesgrowthrate: "売上成長率",
    Netprofitgrowthrate: "純利益成長率",
    StructuralRatios: "構造比率",
    Debtratio: "負債比率",
    Quickratio: "当座比率",
    Currentratio: "流動比率",
  },
  AccountCenterMenu: {
    SearchinSettings: "設定項目を検索",
    Account: "アカウント",
    MyAccount: "マイアカウント",
    ContactInfo: "連絡先情報",
    AccountSecurity: "アカウントセキュリティ",
    OrganizationalManagement: "組織管理",
    UserGroup: "ユーザグループ",
    User: "ユーザ",
    Role: "役割",
    MyDatabase: "マイデータベース",
    MyUsage: "使用状況",
    CompaniesViewed: "閲覧した企業",
    ReportsDownloaded: "ダウンロード済みのレポート",
    ReportUpdatesOrdered: "注文したレポートの更新",
    BillingandPayment: "請求と支払",
    BillRecords: "請求記録",
    PaymentRecords: "支払記録",
    CreditDeductions: "クレジット控除",
    InvoicesDownloaded: "ダウンロードしたインボイス",
    UserSettings: "ユーザ設定",
    Messages: "メッセージ",
    Notifications: "通知",
    HelpCenter: "ヘルプセンター",
    FAQ: "FAQ",
    Privacy: "プライバシー ポリシー",
    Terms: "利用規約",
    ReportIssues: "問題報告",
    UserGuide: "ユーザガイド",
    AboutCSI: "CSIについて",
  },
  MyAccount: {
    Logintime: "ログイン時間",
    SignOut: "サインアウト",
    DeleteAccount: "アカウント削除",
    AccountID: "アカウントID",
    Enteranewaddress: "新しいメールを入力してください",
    EnterVerificationCode: "承認コードを入力してください",
    SendverificationCode: "承認コードを送信してください",
    Password: "パスワード",
    Originalpassword: "旧いパスワード",
    Newpassword: "新しいパスワード",
    Confirmnewpassword: "新しいパスワードの確認",
    AccountOwnership: "アカウント所有権",
    IndividualAccount: "個人口座",
    GroupAccount: "グループアカウント",
    Organizationname: "組織名",
    CountryRegion: "国/地域",
    Address: "アドレス",
    City: "市",
    ZipCode: "郵便番号",
    FirstName: "名",
    LastName: "姓",
    PhoneNumber: "電話番号",
    Email: "メール",
    Change: "変更",
    Save: "保存",
    Cancel: "取消",
    LastLogin: "最後のログイン",
    RecentLogin: "直近のログイン",
    AverageLoginTime: "平均ログイン時間",
    TotalLoginAttempts: "全ログイン回数",
    Registrationtime: "登録時間",
    Role: "役割",
    Administrator: "管理者",
    Enterpriseusers: "企業ユーザー",
    EditImage: "画像編集",
    DeleteImage: "画像削除",
  },
  ContactInfo: {
    ContactInfo: "連絡先情報",
    FirstName: "名",
    LastName: "姓",
    PhoneNumber: "電話番号",
    Email: "メール",
    CountryRegion: "国/地域",
    AddressLine: "アドレスライン",
    City: "市",
    ZipCode: "郵便番号",
    Alternativecontactperson: "緊急連絡先",
    Setascontactperson: "連絡先設定",
    Edit: "編集",
  },
  AccountSecurity: {
    Setupmysecurityquestions: "セキュリティ質問を設定してください",
    Pleasechooseaquestion: "質問を選択してください",
    Pleaseentertheanswertothequestion: "質問の答えを入力してください",
    SessionTimeoutAutomaticLogoutSettings:
      "ログインタイムアウト：自動ログアウト設定",
    Thesystemwillautomatically:
      "一定時間操作がない場合、自動的にログアウトします。デフォルトのタイムアウトは5分ですが、必要に応じて調整できます。",
  },
  MyDatabase: {
    TotalNumberofCompaniesSearched: "検索した会社の総数",
    TotalNumberofCompaniesCollected: "お気に入り会社の総数",
    TotalNumberofUpdateReportsOrdered: "注文した更新レポートの総数",
    Date: "日付",
    UserName: " ユーザー名",
    CompanyName: "会社名",
    Status: "ステータス",
    UsageType: "使用類型",
    Entercompanyname: "会社名を入力してください",
    Download: "ダウンロード",
  },
  OrganizationalManagement: {
    GroupName: "グループ名",
    ParentGroupName: "親グループ名",
    Organization: "組織",
    GroupID: "グループID",
    GroupStatus: "グループ状態",
    Operation: "操作",
    NewlyBuilt: "新規",
    UserAccount: "ユーザアカウント",
    Role: "役割",
    AccountStatus: "アカウント状態",
    RoleName: "役割名",
    Position: "職位",
    RoleStatus: "役割状態",
    Valid: "有効",
    Invalid: "無効",
    PermissionSettings: "権限設定",
    ShowMore: "もっと表示する",
    Search: "検索",
    Cancel: "取消",
    Confirm: "確認",
    NewGroup: "新グループ",
    EnterGroupName: "グループ名入力",
    NumberofGroups: "グループ数",
    Groups: "グループ",
    Roles: "役割",
    NewRoles: "新役割",
    EnterNewRole: "新役割入力",
    Users: "ユーザー",
    EnterUserName: "ユーザー名入力",
  },
  BillingandPayment: {
    TotalNumberofOrders: "注文合計数",
    TotalPaymentAmount: "支払総金額",
    TotalUsedCredits: "利用済みクレジット合計",
    Date: "日付",
    UserAccount: "ユーザアカウント",
    CompanyName: "会社名",
    OrderNo: "注文番号",
    OrderType: "注文種類",
    OrderStatus: "注文状態",
    Download: "ダウンロード",
    PaymentAmount: "支払金額",
    Contactus: "お問い合わせ",
    DownloadInvoice: "インボイスをダウンロードする",
    CreditUsage: "クレジット利用状況",
    ReportOrderStatus: "注文状況を報告する",
    CompanyID: "会社ID",
    CountryRegion: "国/地域",
    AddressLine: "アドレスライン",
    City: "市",
    ZipCode: "郵便番号",
    FirstName: "名",
    LastName: "姓",
    PhoneNumber: "電話番号",
    Email: "メール",
    BankAccountHolderName: "銀行口座保有者名",
    BeneficiaryBankName: "受益者銀行名",
    SWIFTCODE: "SWIFTコード",
    AccountNumber: "アカウント番号",
    BeneficiaryBankAddress: "受益者銀行アドレス",
    ABA: "ABA (ルーティング番号)",
    IBANnumber: "IBAN番号",
    StartingMonth: "開始月",
    EndMonth: "終了月",
    InvoiceInfo: "請求書情報",
  },
  UserSettings: {
    LanguageandLocation: "言語と位置",
    Language: "言語",
    Selectyourpreferedlanguage: "好きな言語を選択してください",
    Location: "位置",
    Selectyourlocation: "あなたの位置を選択してください",
    NotificationSetting: "通知設定",
    EmailNotification: "メール通知",
    ServiceUpdates: "サービス更新",
    CompanyNews: "会社ニュース",
  },
  AddCredit: {
    Customizeyourplan: "必要に応じて計画のカスタマイズ",
    Silver: "シルバー",
    Gold: "ゴールド",
    Enterpris: "企業",
    Credit: "クレジット",
    Remaining: "残り",
    Points: "ポイント",
    Usermonth: "ユーザー/月",
    Useryear: "ユーザー/年",
    PaidMonthlyRenews: "自動更新不要の月間支払",
    PaidAnnuallyRenews: "自動更新不要の年間支払",
    ForFullSupport: "ニーズに対する完全なサポート",
    Each: "毎",
    CreditsCharged:
      "アカウントがアクティブなままである限り、アカウント内のポイント数は期限切れにならない。",
    PaidMonthly: "月単位で購入",
    PaidAnnually: "年単位で購入",
    BuyNow: "今すぐ購入",
    ContactNow: "すぐに連絡",
    SearchCompanies: "企業を検索し、次のような企業データに即時アクセスする",
    EverythinginSilverPackage:
      "シルバーロックコースの内容以外、追加内容は下記のようである",
    CreditsCanbeUsed: "ポイントには次のようなデータサービスが追加される",
    UnlimitedAdvancedSearch: "無制限の拡張検索",
    ViewCompanyProfile: "会社プロフィールの表示",
    CompanyOwnershipStructure: "会社所有権構造",
    CompanyFamilyTree: "会社関連状況",
    Companymanagement: "会社管理層",
    CompanyContactsinfo: "会社連絡先",
    BusinessActivities: "ビジネス活動",
    IndustryBasics: "業界概況",
    ImportExportRecords: "輸出入の歴史",
    CompanyPublications: "会社公開情報",
    CompanyNews: "会社ニュース",
    DownloadOnlineReport: "オンラインレポートのダウンロード",
    ManagementDetails: "管理層詳細",
    ShareholderPenetration: "株主構造図",
    Financialinfo: "財務情報",
    FinancialAnalysis: "財務分析",
    CreditAssessment: "信用評価",
    IndustryAnalysis: "業界分析",
    MarketAnalysis: "市場分析",
    SupplyChaininfo: "サプライチェーン情報",
    CheckSanctions: "制裁情報",
    CompanyComparison: "会社比較",
    DataExport: "データエクスポート",
    MonitoringService: "監視サービス",
    DiscountForFreshUpdateReports: "オフラインレポートサービスの更新",
    SearchCompany: "会社検索",
    SearchLeads: "潜在顧客検索",
    SearchTrade: "貿易検索",
    SearchPeople: "人員検索",
    SearchCountry: "国検索",
    SearchNews: "ニュース検索",
    SearchSanction: "制裁検索 ",
    DataServices: "データサービス",
    APIPlans: "APIカスタマイズ",
    VolumeDiscounts: "ボリューム割引",
    GroupAccountsWithMultipleUsers: "グループアカウントサービス",
    CustomizedPlans: "個性化サービス",
    FreshInvestigatedCreditReportsWorldwide: "最新のグローバル信用レポート",
    BusinessMonitoringServices: "業務監視サービス",
    BusinessProcessVerificationServices: "業務プロセス検証サービス",
    VendorComplianceReports: "ベンダーコンプライアンスレポート",
    MarketResearch: "市場調査",
    More: "その他…",
    Contactus: "お問い合わせ",
    PaymentMethod: "支払い方法",
    CreditCardNumber: "クレジットカード番号",
    EnterCardNumber: "カード番号入力",
    ExpirationDate: "有効期間",
    Fullnameoncard: "カードのフルネーム",
    EnterFullname: "フルネーム入力",
    EnterProvinceState: "都道府県入力",
    CVCCode: "CVCコード",
    EnterCVCCode: "CVCコード入力",
    TotalPurchase: "購買総額",
    Agree1: "「送信」をクリックすると下記内容を同意します ",
    Agree2: "CSIサービスプロトコルとプライバシー。",
    Submit: "提出",
    Month: "月",
    Year: "年",
    Country: "国/地域",
    ProvinceState: "都道府県",
    Cancel: "取消",
    IncorrectCreditCardNumberformat:
      "クレジットカード番号のフォーマットが正しくありません",
    IncorrectExpMonthformat: "有効期限月の形式が正しくありません",
    IncorrectExpYearformat: "有効期限年の形式が正しくありません",
    IncorrectFullNameformat: "フルネームの形式が正しくありません",
    IncorrectCountryformat: "国のフォーマットが正しくありません",
    IncorrectProvinceStateformat: "省/州のフォーマットが正しくありません",
    IncorrectCVCCodeformat: "CVCコードのフォーマットが正しくありません",
  },
  ReportIssues: {
    Whattypeoferrorsyouarereporting:
      "どのような問題をご報告しているでしょうか？",
    Tellusmoreaboutyourproblems: "もっと詳しくご説明ください。",
    Wouldyouliketoprovideascreenshotorafileregardingyourproblem:
      "問題に関するスクリーンショット或はファイルをご提供できるでしょうか？",
    Fillinyourcontactinformation: "連絡先情報を入力してください",
    FirstName: "名",
    LastName: "姓",
    PhoneNumber: "電話番号",
    Email: "メール",
    Edit: "編集",
  },
  //Risk Scan
  RiskScan: {
    RiskScan: "リスクスキャン",
    RiskScanInfo:
      " は、包括的な企業リスク情報を提供する統合プラットフォームです。ビジネス上の意思決定を保護するために、主要なリスクカテゴリごとに詳細な分析を提供します。",
    LegalRisk: "法的リスク",
    LegalRiskInfo: "会社の正当性を検証する",
    OrganizationalRisk: "組織リスク",
    OrganizationalRiskInfo: "管理安定性、企業構造の複雑さ、所有権の透明性",
    OperationalRisk: "組織リスク",
    OperationalRiskInfo: "管理安定性、企業構造の複雑さ、所有権の透明性",
    FinancialRisk: "財務パフォーマンスリスク",
    FinancialPerformanceRiskInfo:
      "収益性トレンド、流動性問題、貸借対照表の健康状態",
    CreditRisk: "信用リスク",
    CreditRiskInfo: "信用、支払履歴、違約確率",
    ComplianceRisk: "コンプライアンスリスク",
    ComplianceRiskInfo: "制裁、反マネーロンダリング規制、業界固有の法律の遵守",
    SustainabilityRisk: "持続可能性リスク",
    SustainabilityRiskInfo: "ESG（環境、社会、ガバナンス）要因と評判影響",
    IndustryRisk: "業界リスク",
    IndustryRiskInfo: "企業の業界全体の安定性と将来性を評価する",
    LetBegin: "始めましょう",
    AddcompaniesfromSearchResult: "検索結果から会社を追加する",
    AddcompaniesfromMyDatabase: "マイデータベースからの会社を追加する",
    Addcompaniesbyuploadmyownlist:
      "自分のリストをアップロードして会社を追加する",
    Cancel: "取消",
    Confirm: "確認",
    UploadFiles: "ファイルのアップロード",
    PleaseuploadyourfileinCVSformat:
      "xlsx形式でファイルをアップロードしてください。",
    Downloadxlsxtemplate: "xlsxテンプレートのダウンロード",
    Xcompanieswereuploadedsucessfuly: "社がアップロードに成功した。",
    Xcompanieswereidentifiedsucessfuly: "社の識別に成功した。",
    Xcompanieswerenotmatched: "社はマッチングしていない。",
    Uploadingfilefailed:
      "ファイルのアップロードに失敗しました。テンプレートを使用して再試行してください。",
    ALL: "全部",
    SearchLeads: "リード検索",
    LastUpdate: "最終更新日",
    CompanyID: "会社ID",
    CompanyType: "会社タイプ",
    RegistrationDate: "登録日",
    RegistrationStatus: "登録状態",
    Listed: "上場",
    LegalStatus: "法的地位",
    NoofShareholders: "株主数",
    ShareholdingLayers: "持株層",
    NoofCorporateShareholders: "会社株主数",
    NoofNatualPersonShareholders: "自然人株主数",
    RelatedCompanies: "関連会社",
    OrganizationalStatus: "組織状態",
    OperatingAddress: "営業住所",
    IndustryCode: "業界コード",
    BusinessActivities: "商業活動",
    NoofEmployees: "従業員数",
    Management: "管理",
    CurrentOperations: "現在経営",
    Revenue: "収入",
    Assests: "資産",
    ProfitLoss: "利益/損失",
    Liquidity: "資産流動性",
    Growth: "成長",
    Performance: "業績",
    CreditRating: "信用格付け",
    CreditScore: "信用点数",
    PausibilityofDefault: "違約可能性（PD）",
    SolvencyIndex: "返済能力指数",
    DebtCollection: "債権回収",
    CreditOpinion: "信用評価",
    CompanySanction: "会社制裁",
    ProductSanction: "製品制裁",
    ExportControl: "輸出規制",
    AntiCorruptionAntiBribery: "反腐敗と反賄賂",
    Litigations: "訴訟",
    NegativeNews: "マイナスニュース",
    ESGScore: "ESGスコア",
    YearsinBusiness: "経営年限",
    Competitiveness: "競争力",
    WorkingCapital: "運営資金",
    FinancialStructure: "財務構造",
    Industrystatus: "業界ステータス",
    IndustryOutlook: "業界展望",
    NoofCompanies: "会社数",
    IndustryRanking: "業界ランキング",
    IndustryConcentration: "業界GDP%",
    IndustryCompetitiveness: "業界競争力",
    IndustryDevelopment: "業界発展",
    CompanyName: "会社名",
    Legal: "法律",
    Organizational: "組織",
    Operational: "営業",
    Financial: "金融",
    Credit: "信用",
    Compliance: "コンプライアンス",
    Sustainability: "持続可能性",
    Industry: "業界",
    Download: "ダウンロード",
    StartDate: "開始日",
    EndDate: "終了日",
    Entercompanyname: "会社名を入力してください",
    Uploadyourlistofcompanies:
      "企業リストをアップロードすると、リスクスキャンが各企業に関するデータを即座に更新します。8つのリスクカテゴリーにわたる包括的なリスク評価により、Risk Scanはリスク管理を事後対応型から事前対応型の戦略的優位性へと変革します。",
    Select: "選択",
    Upload: "アップロード",
    Uploading: "アップロード中",
    Uploadwithamaximumfilesizeof1M:
      "（一度に最大100件までアップロード可能、ファイルサイズ上限は1MB） ",
    Tryagain: "再試行",
    Theuploadedonlyxlsx:
      "アップロードできるファイル形式はxlsまたはxlsxのみです",
    Scanning: "スキャン中",
    RiskScanning: "リスクスキャン中",
    Youhaveselectedatotalof: "選択した企業は合計",
    Tostartriskscanning:
      "社です。「確認」をクリックするとリスクスキャンを開始します",
    Datascanningisinprogress: "データスキャンが進行中です",
    ClearAll: "すべてクリア",
    Selectdate: "日付を選択",
    UpdateStatus: "更新ステータス",
    Updated: "更新済み",
    Notupdated: "未更新",
    Updating: "更新中",
    Selectrisklevel: "選択リスクレベル",
    Low: "低",
    Average: "平均",
    Caution: "注意",
    NotRated: "未評価",
    Reselect: "再選択",
    HistoricalRecords: "履歴記録",
    DownloadReport: "レポートをダウンロード",
    ScanDate: "スキャン日",
    ReSelectData: "データを再選択",
    HistoricalData: "履歴データ",
    ScanHistoricalData: "履歴データをスキャン",
  },
  //Data Management
  DataManagement: {
    DataManagement: "データ管理",
    AllCompanies: "すべての会社",
    CompaniesViewed: "閲覧される会社",
    CompaniesCollected: "収集した会社",
    CompaniesUploaded: "アップロードした会社",
    MyPortfolio: "マイポートフォリオ",
    Date: "日付",
    CompanyName: "会社名",
    Country: "国",
    CompanyType: "会社タイプ",
    CompanyStatus: "会社ステータス",
    DQI: "DQI",
    Download: "ダウンロード",
    Addcompanies: "会社の追加",
    Filter: "フィルター",
    Selectcountry: "国選択",
    Selectindustry: "業界選択",
    Selectcompanytype: "会社タイプ選択",
    Selectcompanysize: "企業規模選択",
    Selectcompanystatus: "会社ステータス選択",
    Selectlistedcompanies: "上場企業選択",
    Selectcompanyyearsinbusiness: "会社営業年数選択",
    Industry: "業界",
    CompanySize: "企業規模",
    Listed: "上場",
    CompanyAge: "会社運営年数",
    SelectYear: "年選択",
    SelectQuarter: "四半期選択",
    SelectMonth: "月選択",
    Reset: "リセット",
    Search: "検索",
    MyDatabase: "マイデータベース",
    Locations: "拠点分布",
    YearsinBusiness: "経営年数",
    CompanyDQI: "会社DQI",
    RiskScan: "リスクスキャン",
    CreditAssessment: "信用評価",
    Uptodate: "最新",
    Average: "普通",
    Insufficient: "不十分",
    Good: "良い",
    Caution: "警告",
    Unknown: "未知",
    CompanyTag: "会社ラベル",
    Remove: "削除",
    Uploaded: "アップロード済み",
    Identified: "認識済み",
    Notmatched: "一致しない‌",
    UploadCompanies: "会社をアップロード",
    Match: "照合",
    Delete: "削除",
    OnlineMatching: "オンライン照合",
    Identifythecompanywithmanualcheck: "手動検査による会社の識別",
    Identifyacompanymanually: "会社を手動で識別する",
    Pleaseprovideanyrelevantinformation:
      "検索結果を強化する可能性のある情報を提供してください。データアナリストが、最適な企業にマッチさせます。",
    RegistrationID: "登録ID",
    StateProvince: "都道府県",
    Address: "住所",
    Otherinformation: "その他情報",
    Submit: "送信",
    Cancel: "取消",
    Confirm: "確認",
    EnterRegistrationID: "登記IDを入力",
    EnterAddress: "住所を入力",
    EnterInformation: "情報を入力",
    PortolioName: "ポトシオ名",
    User: "ユーザー",
    Task: "タスク",
    NoofCompanies: "会社数",
    Entercompanyname: "会社名を入力してください",
    SaveYourPortfolio: "ポートフォリオの保存",
    PortfolioName: "ポートフォリオ名",
    Notes: "備考",
    Edit: "編集",
    EnterPortfolioName: "ポートフォリオ名を入力",
    EnterUserName: "ユーザーを入力",
    SelectTaskName: "タスクを選択",
    EnterNotes: "備考を入力",
    StartingMonth: "開始月",
    EndMonth: "終了月",
  },
  //Search Relationship
  Relationship: {
    SearchRelationship: "関係検索",
    SearchRelationshipInfo:
      " は当社の最上級データサービス。あらゆる企業の包括的なコーポレートエコシステムを可視化し、調査対象企業の 360° 全体像を提供します:",
    UltimateOwnershipControl: "最終所有・支配構造",
    UltimateOwnershipControlInfo:
      "複雑な所有層を追跡し、UBO（実質的支配者）と全株主を特定。",
    InvestmentParticipation: "投資・提携関係",
    InvestmentParticipationInfo:
      "出資先、パートナー、参加企業を網羅。戦略的方向性と隠れた提携を発見。",
    SupplyChainNetwork: "サプライチェーンネットワーク",
    SupplyChainNetworkInfo:
      "取引先・仕入先を含む商流を把握し、事業の全体構造を理解。",
    Ourplatformempowers:
      "サーチ・リレーションシップは、機会の発見、コンプライアンスの効率化、リスク低減を支援。透明性は、検索ひとつで。",
    LetsBegin: "始めましょう",
    CompanyName: "企業名",
    Country: "国・地域",
    Industry: "業種",
    CompanyType: "会社形態",
    CompanySize: "企業規模",
    CompanyStatus: "企業ステータス",
    ListingInfo: "上場情報",
    YearsinBusiness: "設立年数",
    IncDate: "株式会社成立日",
    HSCode: "HSコード",
    Company: "会社名",
    Product: "製品",
    HsCodeProduct: "HSコード / 製品",
    ImportExport: "輸入＆輸出",
    Entercompanyname: "企業名を入力してください",
    SelectHsCodeProduct: "HSコード/製品を選択する",
    CompanySnapshot: "企業概要",
    Address: "住所",
    CountyCity: "市区町村",
    ProvinceState: "都道府県",
    CountryRegion: "国/地域",
    ZipCode: "郵便番号",
    RegName: "登記名",
    Website: "ウェブサイト",
    Email: "メール",
    Phone: "電話",
    LastUpdate: "最終更新日",
    DataSource: "データソース",
    CompanyProfile: "企業プロフィール ",
    CoNativeName: "会社名",
    CompanyID: "会社ID",
    VATNumber: "VAT番号",
    StockNumber: "株式番号",
    Listed: "上場状況 ",
    RegistrationDate: "登記日",
    LegalForm: "法的形態",
    LegalStatus: "法的地位",
    Jurisdiction: "管轄区域",
    RegisteredAddress: "登記住所",
    OperatingAddress: "営業住所",
    Ownership: "所有権",
    Investments: "投資",
    PossibleVendors: "想定仕入先",
    PossibleClients: "想定顧客",
    UItimateBeneficiaryOwner: "最終受益者 (UBO)",
    ControllingShareholder: "支配株主",
    Participations: "出資・参加先",
    ShareholdingLayers: "持株階層",
    PartiesInvolved: "関係者合計",
    RelatedCompanies: "関連会社",
    CompanyShareholders: "会社株主",
    CoShareholders: "会社株主",
    NGOShareholders: "NGO株主",
    NaturalPersonShareholders: "自然人株主",
    SubjectsInvestments: "対象企業の投資先",
    CorporateShareholders: "企業株主",
    Name: "名称",
    Location: "所在地",
    Type: "種別",
    Shares: "持株比率（％）",
    Relations: "関係性",
    TotalEntities: "総事業体数",
    Entities: "エンティティ数",
    Subsidiaries: "子会社",
    Countries: "国/地域",
    Branches: "支店",
    Relationship: "関係性",
    RelationType: "関連タイプ",
    RelationLevel: "関連階層",
    Management: "経営陣",
    ContactInfo: "連絡者",
    Position: "職位",
    Department: "部門",
    ShareholderorNot: "株主か否か",
    Pleaseentername: "名前を入力してください",
    SupplyChain: "サプライチェーン",
    PossibleClients: "想定顧客",
    PossibleSuppliers: "想定仕入先",
    Banking: "銀行取引",
    TotalSales: "売上合計",
    TotalPurchasing: "購買合計",
    ActivePlayers: "活動参加者",
    MainProductsServices: "主な製品・サービス",
    TotalTradingVolume: "取引量合計",
    TransactionTotal: "取引/合計（％）",
    RecentTradeDate: "最近取引日",
    IndustryCode: "業界コード",
    TradeRelatedCompanies: "取引関連企業",
    TradeRelatedProductTOP10: "取引関連製品TOP10",
    Numberofshareholderenterprises: "株主数",
    CurrentLevel: "持株階層",
    SharesonSubjectCo: "対象企業持株比率",
    EnterCurrentLevel: "現在の階層を入力",
    EnterCountry: "国・地域を入力",
    ClearAll: "すべてクリア",
    ShareholderLevel: "株主階層",
    DirectShareholdingPercentage: "直接持株比率",
    TotalOwnershipPercentage: "総持株比率",
    InvestmentHoldingLevel: "控股階層",
  },

  SearchSanctions: {
    CountryISO: "国家ISO",
    Currency: "通貨",
    Language: "言語",
    SanctionOtherCountries: "他国への制裁",
    SanctionedbyOtherCountries: "他国からの制裁",
    CountriesTerritories: "国/地域",
    Selectcountryterritory: "国選択",
    Noofcountriessanctionedby: "制裁されている国の数",
    Noofcountriesthatsanctioned: "制裁の対象国数",
    Noofsanctionedcompanies: "制裁対象企業数",
    Noofsanctionedpersonnel: "裁断対象人員数",
    SanctionOverview: "制裁概要",
    NoofSanctions: "制裁回数",
    TypesofSanctions: "制裁タイプ",
    SourceofSanctions: "制裁ソース",
    Provider: "プロバイダ",
    Description: "記述",
    Details: "詳細",
    ClearAll: "すべてクリア",
    Sanctions: "制裁",
    SanctionID: "制裁ID",
    SelectsanctionID: "制裁ID選択",
    SanctionedType: "制裁タイプ",
    SelectSanctionedType: "制裁タイプ選択",
    CompanyPersonnel: "会社/人員",
    Selectcompanypersonnel: "会社/個人選択",
    SanctionCategory: "制裁カテゴリ",
    Selectsanctioncategory: "制裁カテゴリ選択",
    SanctionSource: "制裁ソース",
    Selectsanctionsource: "制裁ソース選択",
    Status: "状態",
    Selectstatus: "状態選択",
    CountryofSource: "ソース国",
    Name: "名前",
    SanctionedCountries: "制裁対象国",
    SanctionType: "制裁タイプ",
    Reference: "参考",
    ProviderCode: "プロバイダコード",
    RecordSource: "レコードソース",
    CompanyName: "会社名",
    Country: "国",
    SelectCompanyName: "会社名を選択",
    SelectCountry: "国/地域選択",
    SanctionInfo: "制裁情報",
    SanctionRelated: "制裁関連",
    OwnershipRelatedCompanies: "所有権と関連会社",
    OfficialSanctionList: "公式制裁リスト",
    RegName: "登記名",
    Address: "住所",
    Website: "ウェブサイト",
    Email: "メール",
    ProvinceState: "都道府県",
    Tel: "電話",
    CountryRegion: "国/地域",
    LastUpdate: "最終更新日",
    ZipCode: "郵便番号",
    DataSource: "データソース",
    Relations: "関係性",
    DOB: "生年月日",
    Gender: "性別",
    All: "全部",
    FirstName: "名",
    MiddleName: "ミドルネーム",
    LastName: "姓",
    PreviousName: "旧名",
    Type: "タイプ",
    PlaceofBirth: "出生地",
    Citizenship: "市民権",
    Residence: "所在地",
    Juristiction: "管轄地",
    History: "歴史",
    Category: "カテゴリー",
    Title: "タイトル",
    SanctionRecord: "制裁記録",
    OfficialSanctionList: "公式制裁リスト",
    Relationship: "関係",
    HSCode: "HSコード",
    ProductName: "製品名",
    SanctionedCountryRegion: "制裁対象国/地域",
    LawEnforcement: "法執行機関",
    EnforcementOrders: "執行命令",
    Warnings: "警告",
    FinancialSanctions: "金融制裁 ",
    ExclusionList: "除外リスト",
    TradeRestrictions: "貿易制限",
    VisaTravelBan: "ビザ/旅行禁止令",
    WarCrimes: "戦争犯罪",
    NoData: "データなし",
    Advisories: "お知らせ",
    Others: "その他 ",
    Selectsanctiontype: "制裁タイプを選択",
    Selectreference: "参照を選択",
    From: "開始日",
    To: "終了日",
    CountryCity: "国／都市",

    SearchPersonName: "人名で検索",
    SelectDOB: "生年月日を選択",
    Male: "男性",
    Female: "女性",
    SelectRecordSource: "記録ソースを選択",
    ProfileNotes: "プロフィール備考",
    Sources: "情報源",
    DescriptionofReferenceName: "参照名称の説明",
    SelectHSCode: "HSコードを選択",
    SelectProductName: "製品名を選択",
    SelectSanctionedCountryRegion: "制裁対象国・地域を選択",
  },
  SearchTrade: {
    LastUpdate: "最終更新日",
    ProductCode: "製品コード",
    ProductDescription: "製品説明",
    Sanctions: "制裁",
    TotalImports: "総輸入量",
    TotalExports: "総輸出量",
    TotalImportWeight: "総輸入重量",
    TotalExportWeight: "総輸出重量",
    NumberofSuppliers: "サプライヤー数",
    NumberofBuyers: "購入者数",
    NumberofOriginCountries: "原産国の数",
    NumberofDestinationCountries: "仕向国の数",
    detailconttext:
      "アクセスしようとしている機能は、当社プレミアム会員特典の一部です。この機能および全てのプレミアム特典をご利用いただくには、会員プランへご登録ください。",
    OK: "OK",
    Close: "閉じる",
    Subscribe: "登録する",
    TradeMap: "トレードマップ",
    Imports: "輸入",
    Exports: "輸出",
    Reset: "リセット",
    Product: "製品",
    Destination: "目的地",
    Origin: "出発地",
    NoData: "データなし",
    Date: "日付",
    TotalTransactions: "合計トランザクション数",
    Transactions: "取引",
    TradeRanking: "貿易ランキング",
    Top5Ranking: "トップ5 ランキング",
    Growth: "成長",
    Decline: "減少",
    TradeTrends: "貿易動向",
    TradeVolume: "取引量",
    MonthonMonthRatio: "前月比",
    Suppliers: "サプライヤー",
    Buyers: "バイヤー ",
    StartDate: "開始日",
    EndDate: "終了日",
    SelectCountry: "国/地域選択",
    SelectCompany: "会社を選択",
    ClearAll: "すべてクリア",
    TransactionDate: "取引日",
    SelectTransactionDate: "取引日を選択",
    Company: "会社",
    CompanyName: "会社名",
    Country: "国",
    Industry: "業種",
    Enterkeywords: "キーワードを入力してください",
    SupplierOverview: "サプライヤー概要",
    BuyerOverview: "バイヤー概要",
    CompanyID: "会社ID",
    ISIC: "ISICコード",
    ISICDescription: "ISICコードの説明",
    TotalTradeAnnual: "年間総取引額",
    TotalTradePastsixmonth: "過去6ヶ月間の総取引額",
    ContactInformation: "連絡先情報",
    ShippingOverview: "出荷概要",
    TradeHistoryandTrends: "貿易履歴とトレンド",
    SupplyChainList: "サプライチェーン一覧",
    PossibleBuyers: "潜在的な購入者",
    PossibleSuppliers: "潜在的な供給業者",
    ShowAll: "すべて表示",
    TotalExportsAnnual: "年間総輸出額",
    TotalImportsAnnual: "年間総輸入額",
    ExportAmount: "輸出金額",
    ImportAmount: "輸入金額",
    ShipmentDetail: "出荷明細",
    Entersuppliername: "サプライヤー名を入力 ",
    Enterbuyername: "バイヤー名を入力",
    SupplierName: "サプライヤー名",
    BuyerName: "バイヤー名",
    TotalAmount: "総額 (USD)",
    Details: "詳細",
    WaybillDetails: "ウェイビル明細",
    ListofOrigins: "原産地一覧",
    ListofDestinations: "目的地一覧",
    ISO: "ISO",
    Currency: "通貨",
    Language: "言語",
    Address: "住所",
    OverviewofSupplyChainInformation: "サプライチェーン情報概要",
    OriginInformationOverview: "原産地情報概要",
    DestinationInformationOverview: "目的地情報概要",
    SanctionType: "制裁タイプ",
    SelectSanctionType: "制裁タイプを選択",
    SanctionedCountryRegion: "制裁対象国/地域",
    SelectSanctionedCountryRegion: "制裁対象国・地域を選択",
    HSCode: "HSコード",
    SanctionedProductsOverview: "制裁対象製品の概要",
    Searchmoresanctiononothercompanies: "他社の制裁情報をさらに検索",
    SimilarProducts: "類似商品",
    Numberofsimilarproducts: "類似商品数",
    TopImportCountries: "トップ5輸入国",
    TopExportCountries: "トップ5輸出国",
    PleaseSelect: "選択してください",
    EnterHSCodeProductName: "HSコード＆商品名を入力",
    ImportProducts: "輸入商品",
    ExportProducts: "輸出商品",
    NumberofOrigin: "原産地数",
    NumberofDestination: "目的地数",
    NumberofImportProducts: "輸入商品数",
    NumberofExportProducts: "輸出商品数",
    ProductName: "製品名",
    SelectProductName: "製品名を選択",
    TopExportProducts: "トップ5輸出商品",
    TopImportProducts: "トップ5輸入商品",
    ExportProductOverview: "輸出商品概要",
    ImportProductOverview: "輸入商品概要",
    CompanyCompetitiveness: "企業競争力",
    GlobalMarketShare: "グローバル市場シェア",
    RegionalMarketShare: "地域別市場シェア",
    BusinessGrowthGlobalMarket: "事業成長（グローバル市場）",
    BusinessGrowthRegionalMarket: "事業成長（地域市場）",
    CreditRating: "信用格付け",
    CreditAssessment: "信用評価",
    LocalCreditScore: "ローカル与信点数",
    SolvencyIndex: "ソルベンシー指数",
    ProbabilityofDefault: "違約率",
    RiskIndicator: "リスク指数",
    RelatedCreditAssessment: "関連与信格付",
    HighRisk: "ハイリスク",
    Medium: "ミディアムリスク",
    Moderate: "モデレートリスク",
    Average: "平均",
    LowerThanAvg: "平均以下",
    LowRisk: "ローリスク",
    CreditOpinion: "信用評価",
    ComparisonofSimilarProducts: "類似製品の比較",
    AddProduct: "商品を追加",
    RegistrationDate: "登記日",
    Profit: "利益",
    NoofShareholders: "株主数",
    TotalAssets: "総資産",
    IndustryCode: "業界コード",
    NoofEmployees: "従業員数",
    CreditScore: "信用点数",
    Listed: "上場状況",
    ESGRating: "ESGレベル",
    Revenue: "収入",
    DQI: "DQI",
    MoreCoDetails: "会社情報をもっと見る",
    CoNews: "社内ニュース",
    MoreCoNews: "会社ニュースをもっと見る",
    IndustryMean: "業界平均値",
    TargetSubjectRevenue: "目標売上",
    ImportCountries: "輸入相手国",
    ExportCountries: "輸出相手国",
    ImportCompanyTop: "輸入会社ランキング1位",
    ExportCompanyTop: "輸出会社ランキング1位",
    TopImportCountry: "最大輸入国",
    TopExportCountry: "最大輸出国",
    Max: "Max",
    Min: "Min",
    Subject: "Subject",
    ReturnonEquity: "純資産収益率",
    ProfitMargin: "粗利",
  },

  TradeByCountry: {
    ImpExpCountries: "輸出入国",
    ImpExpCompanies: "輸出入企業",
    ImpExpProducts: "輸出入製品",
    Assessment: "評価",
    TotalImportAmount: "輸入総額",
    GlobalImportShare: "世界シェア（輸入）",
    ImportGrowth: "輸入成長率",
    TotalExportAmount: "輸出総額",
    GlobalExportShare: "世界シェア（輸出）",
    ExportGrowth: "輸出成長率",
    TradeBalance: "貿易収支",
    CountryData: "国別データ",
    GDP: "GDP",
    GDPPPP: "GDP (PPP)",
    ExportsofGoods: "財輸出額",
    ExportsofServices: "サービス輸出額",
    ImportsofGoods: "財輸入額",
    ImportsofServices: "サービス輸入額",
    CPI: "CPI",
    Population: "人口",
    ContainerPortThroughput: "コンテナ港湾取扱量",
    DistributionofImportExportCountries: "輸出入国分布",
    Top5Ranking: "トップ5 ランキング",
    Importers: "输入者",
    Exporters: "输出者",
    ImportCountries: "輸入相手国",
    ExportCountries: "輸出相手国",
    ImportProducts: "輸入製品",
    ExportProducts: "輸出製品",
    CountryImportExportOverview: "国別輸出入概要",
    Year: "年",
    Amount: "金額 (USD)",
    Balance: "収支",
    CountryTradeDataComparison: "国別貿易データ比較",
    Comparison: "比較",
    AddSample: "サンプルを追加",
    AddCriteria: "条件を追加",
    ImportCountry: "輸入相手国",
    Selectimportcountries: "輸入国を選択",
    ExportCountry: "輸出相手国",
    Selectexportcountries: "輸出国を選択",
    EnterproductnameorHSCode: "HSコード＆商品名を入力",
    Afterselectingthecriteria: "条件を選択後、比較結果が表示されます。",
    ShowResult: "結果を表示",
    ListofTradeCompanies: "貿易企業リスト",
    TotalCompanies: "企業総数",
    Top5Products: "トップ5製品",
    ListofExportProducts: "輸出製品リスト",
    ListofImportProducts: "輸入製品リスト",
    Top5ExportCountries: "トップ5輸出国",
    Top5ImportCountries: "トップ5輸入国",
    HSDescription: "HS説明",
    HSCode: "HSコード",
    TradeCompetitivenessIndex: "貿易競争力指数",
    TotalTradeAmount: "貿易総額",
    NetTradeBalance: "純貿易収支",
    TradeGap: "貿易ギャップ",
    TradeGoodsExports: "貿易財輸出",
    TradeGoodsImports: "貿易財輸入",
    TradeServicesExports: "貿易サービス輸出",
    TradeServicesImports: "貿易サービス輸入",
    CompositePMI: "総合PMI",
    ServicesPMI: "サービス業PMI",
    LegalEnvironment: "法制度環境",
    CorporateTaxRate: "法人税率",
    PersonalIncomeTaxRate: "所得税率",
    SalesTaxRate: "消費税率",
    BusinessConfidenceIndex: "企業景況感指数",
    CountryRating: "国別格付",
    CompetitivenessIndex: "競争力指数",
    CompetitivenessRank: "競争力ランキング",
    EaseofDoingBusiness: "ビジネスのしやすさ",
    BusinessConfidence: "企業信頼感",
    ConsumerConfidence: "ビジネス環境評価",
    BusinessClimateAssessment: "ビジネス環境評価",
    SP: "S&P",
    Moodys: "ムーディーズ",
    Fitch: "フィッチ",
    DBRS: "DBRS",
    Allianz: "アリアンツ",
    Coface: "コファス",
    Atradius: "アトラディウス",
    OECD: "OECD",
    SearchTrade: "貿易検索",
    Productivecapacitiesindex: "生産能力指数",
    NominalGNI: "GNI（名目）", //不要
    Ecommercesales: "Eコマース売上高", //不要
    PleaseSelect: "選択してください",
    transactionvolume: "取引量",
    Growth: "成長",
    Decline: "減少",
    SelectCountry: "国を選択",
    TradeVolume: "貿易額",
    CountryTradeDataComparison: "国別貿易データ比較",
    Youcanonlyaddupto5datacomparisonitems: "比較項目は最大5件まで追加できます",
    DataComparisonActive: "データ比較（有効）",
    DataComparisonBlack: "データ比較（無効",
    ProductName: "製品名",
    Product: "製品",
    Date: "日付",
    OverviewofAnalysisContent: "分析内容の概要",
    Afterselectingthecriteria: "条件を選択した後,",
    thecomparisonresultwillbedisplayed: "比較結果が表示されます.",
    ImportExport: "輸入＆輸出",
    All: "全部",
    Company: "会社",
    SelectCompanyName: "会社名を選択",
    SelectProductName: "製品名を選択",
    CompanyID: "会社ID",
    CO: " C/O",
    ISIC: "ISIC",
    ISICDescription: "ISIC説明",
    Top5ExportProducts: "トップ5輸出製品",
    Top5ImportProducts: "トップ5輸入製品",
    ContactInformation: "連絡先情報",
    SearchTrade: "貿易検索",
    NumberofImportProducts: "輸入商品数",
    NumberofExportProducts: "輸出商品数",
    TransactionYear: "取引年度",
    SelectTransactionYear: "取引年度を選択",
    Totalnumberofimportedproducts: "輸入製品総数",
    Totalnumberofexportedproducts: "輸出製品総数",
    Updateyear: "更新年度",
    TotalTrade: "貿易総額",
    ISO: "ISO",
    Currency: "通貨",
    Language: "言語",
  },
  LeadsAIAssistance: {
    SavedAnswers: "アンケートの保存",
    SearchLeads: "検索リーズ",
    SearchLeadsMessage1:
      "検索リーズは、企業ユーザーが潜在的な顧客やベンダーと連絡を取るのを支援する強力なツールである。先端機械学習技術の推進の下で、私たちのプラットフォームは大量のデータセットを分析し、カスタマイズの正確な提案を提供する。",
    SearchLeadsMessage2:
      "システムは、ユーザーの目標、市場動向、リスク耐性、履歴データを考慮し、特定のニーズと好みに最適な製品またはサービスを特定する。",
    SearchLeadsMessage3:
      "「手がかり検索」では、提案が相関性と正確性を維持するように学習と発展を続けている。操作性のある見解を提供することにより、企業は最も有望な顧客やベンダーを特定しながら、時間とリソースを節約することができる。",
    SearchLeadsMessage4:
      "システムが会社のリストを推薦するためには、いくつかの質問に答える必要がある。",
    LetBegin: "今すぐ開始",
    Selectallthatapply: "該当するもの全てを選択",
    Savemyanswers: "回答を保存",
    Showresults: "結果を表示",
    Yoursearchcriteriaforcustomeracquisition: "顧客獲得の検索条件",
    Doyouliketosaveyourcurrentselectionsofsearchcriteria:
      "現在の検索条件を保存しますか？",
    Pleasenameyourcondition: "条件名を入力してください",
    Pleaseenterthetemplatename: "テンプレート名を入力してください",
    NoSave: "保存しない",
  },
  SearchLeadsList: {
    Filters: "フィルター",
    Questionnaire: "アンケート",
    Country: "国",
    CompanyType: "会社タイプ",
    CompanySize: "会社規模",
    OperationalStatus: "会社ステータス",
    YearsinBusiness: "営業年数",
    NumberofEmploees: "従業員数",
    Fortune500: "世界トップ500",
    Listed: "上場するかどうか",
    ImportExport: "輸入&輸出",
    TotalAssets: "総資産",
    Revenue: "収入",
    Profitability: "収益性",
    CreditRating: "信用格付け",
    Foundover: "検出が超過しました",
    Changeseach: "再ロード",
    Refreshformore: "バッチを入れ替える",
    CompanyNumber: "会社番号",
    Address: "アドレス",
    Lockinlist: "リストをロックする",
    ContactInformation: "連絡先情報",
    SupplyChainList: "サプライチェーン一覧",
    IndustryInfo: "業界情報",
    LeadScore: "リードスコア",
    AccuracyScale: "精度スケール",
    RegistrationDate: "登記日",
    Profit: "利益",
    NoofShareholders: "株主数",
    TotalAssets: "総資産",
    IndustryCode: "業界コード",
    NoofEmployees: "従業員数",
    CreditScore: "信用点数",
    Listed: "上場状況",
    ESGRating: "ESGレベル",
    Revenue: "収入",
    DQI: "DQI",
    MoreCoDetails: "会社情報をもっと見る",
    CoNews: "社内ニュース",
    MoreCoNews: "会社ニュースをもっと見る",
    NationalIndustryData: "全国業界データ",
    LastUpdate: "最終更新日",
    IndustryandCountryOverview: "業界と国の概要",
    CountryName: "国名",
    BusinessEnvironment: "ビジネス環境",
    LegalEnvironment: "法的環境",
    ConfidenceIndex: "クレジット指数",
    NationalCompetitivenessIndex: "国家競争力指数",
    NationalGDP: "国家GDP",
    Industrysituationoftheaffiliatedcompany: "関連会社の業界状況",
    Subjectcompanyindustrydescripti: "ターゲット企業の業界説明",
    Targetenterpriseindustrycode: "ターゲット企業の業界コード",
    Industryscalesegmentation: "業界規模の細分化",
    Quantity: "数量",
    SubjectCompany: "対象会社",
    Industryyearsegmentation: "業界の年限細分化",
    Industryoperationsituation: "業界運営の詳細",
    Tips: "ヒント",
    Areyousureyouwanttodeletethisdata: "このデータを削除してもよろしいですか",
  },
  SearchLeadsContact: {
    ContactInformation: "連絡先情報",
    OrganizationalFramework: "組織体制",
    NumberofPersonnel: "従業員数",
    NumberofDepartments: "部門数",
    NumberofCalls: "通話回数",
    NumberofEmails: "メール送信数",
    MiningRate: "抽出率",
    AuthenticationRate: "認証率",
    Name: "氏名",
    Department: "部署",
    Position: "役職",
    Country: "国",
    Email: "メールアドレス",
    Phone: "電話番号",
    SocialMediaAccounts: "SNSアカウント",
    AuthenticationStatus: "認証状況",
    AddStatus: "登録状況",
    Doyouhaveanemailaddress: "メールアドレスの有無?",
    Isthereatelephone: "電話番号の有無?",
    Authenticationrequired: "認証必須",
    Addornot: "登録有無?",
    Added: "登録済み",
    BulkEmailSending: "一括メール送信",
    BatchAuthentication: "一括認証",
    AddCustomers: "顧客登録",
    AIEmailAssistant: "AIメールアシスタント",
    ClearAll: "すべてクリア",
    EnterName: "氏名を入力",
    EnterDepartment: "部署を入力",
    EnterPosition: "役職を入力",
    EnterCountry: "国を入力",
    Yes: "はい",
    No: "いいえ",
    EnterSocialMediaAccount: "SNSアカウントを入力",
    Certified: "認証済み",
    Unverified: "未認証",
    InformationAuthentication: "情報認証",
    AuthenticationMethod: "認証方法",
    Iwanttoclaimit: "申請する",
    IwanttoclaimitMessage: "知人を認証できます。",
    AuthenticationService: "認証サービス",
    AuthenticationServiceMessage:
      "認証したい担当者を選択し、オフライン認証サービスをシステムに依頼できます。",
    UploadedList: "アップロード済みリスト",
    DownloadTemplate: "テンプレートをダウンロード",
    Upload: "アップロード",
    ListofCertifiedPersonnel: "認証済み担当者リスト",
    AIEmailAssistantTitle:
      "AIメールアシスタントをご利用いただきありがとうございます。",
    AIEmailAssistantMessage:
      "人工知能を活用して、対象企業の担当者および連絡先情報を詳しく掘り下げてご案内します。",
    EmailSending: "メール送信",
    RecipientInformation: "宛先情報",
    SelectedList: "選択済みリスト",
    Pleaseenteryourname: "お名前を入力してください",
    SenderInformation: "送信者情報",
    CompanyName: "会社名",
    EmailContent: "メール本文",
    EmailConfirmationMessage: "メール確認メッセージ",
    Hellodearuser: "ユーザーの皆様へ",
    Message:
      "このメールの送信者は、CSIプラットフォームを通じて貴社の連絡先情報を取得し、ご連絡を希望しております。直接返信してビジネス関係を築くか、プラットフォームのカスタマーサービスにメールを送信してください。システムが代わりにユーザーへ連絡いたします。",
    CSIWebsite: "CSIウェブサイト",
    CSICustomerServiceEmail: "CSIカスタマーサービスメール",
    EnterCompanyName: "会社名を入力してください",
    EnterEmail: "メールアドレスを入力してください",
    EnterPhone: "電話番号を入力してください",
    Pleaseenteremailcontent: "メール本文を入力してください",
    Cancel: "キャンセル",
    Submit: "送信",
    Return: "戻る",
    Close: "閉じる",
    All: "すべて",
    Addcustomerconfirmationlist: "顧客登録確認リスト",
    AddCustomersMessage:
      "表内の個人を自分の顧客リストに追加してもよろしいでしょうか。（マイページ）",
    Addlist: "追加リスト",
  },
  ...jaLocale,
};

export default jp;
